import React from "react";
import { FormGroup, Input } from "reactstrap";

function SelectorPrioridad(props){
    const {Valor, setValor} = props;
    
    const cambiarValor = event => {
        setValor(event.target.value);
    };

    return(
        <>
            <FormGroup>
                    <Input id="exampleFormControlSelect1" type="select" 
                        value={Valor}
                        onChange={cambiarValor}
                    >
                        <option value={''}>Opciones..</option>
                        <option value={1}>ALTA</option>
                        <option value={2}>MEDIA</option>
                        <option value={3}>BAJA</option>
                    </Input>
            </FormGroup>
        </>
    );
};

export default SelectorPrioridad;